import { cn } from "@/lib/utils";

type FrameProps = {
  children: React.ReactNode;
  className?: string;
};

/* Layout component for steps */
const Frame = ({ children, className }: FrameProps): JSX.Element => {
  return (
    <div className={cn("flex flex-col gap-y-6", className)}>{children}</div>
  );
};

export default Frame;
